module.exports = __webpack_public_path__ + "static/media/physics.118ab7b7.png";